module.exports = __webpack_public_path__ + "img/BecomePan-4.516ebe2e.svg";